import api from "../index";

export const GetFileReportApi = (data) => api.post('admin-file-list', data);
export const GetAuditReportApi = (data) => api.post('file-audit-trial', data);
export const GetPaymentReportApi = (data) => api.post('payment-list', data);
export const ApprovePaymentApi = (data) => api.post('approved-payment-by-admin', data);
export const RejectPaymentApi = (data) => api.post('rejected-payment-by-admin', data);
export const GetInvoiceReportApi = (data) => api.post('invoice-list', data);
export const GetSignatureReportApi = (data) => api.post('signature-report', data);
export const ExportFileReportApi = (data, headers) => api.post('export-all-file-data', data, headers);
export const GetSignatureAuditReportApi = (data) => api.post('signature-audit-report', data);
